// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { submitFormData } from '../../../pages/api';

// // Updated InputField component to handle readOnly
// const InputField = ({ label, name, value, onChange, type = 'text', section, field, readOnly = false, ...props }) => (
//   <div>
//     <label className="block font-semibold mb-1">{label}</label>
//     <input
//       type={type}
//       name={name}
//       value={value || ''}
//       onChange={(e) => !readOnly && onChange(e, section, field)} // Prevent changes if readOnly
//       readOnly={readOnly}
//       className={`w-full p-2 border rounded focus:ring-2 focus:ring-gray-500 ${
//         readOnly ? 'bg-gray-100 text-gray-600 cursor-not-allowed' : 'border-gray-300'
//       }`}
//       {...props}
//     />
//   </div>
// );

// // Updated FieldGroup component to pass readOnly to InputField
// const FieldGroup = ({ title, section, fields, formData, handleChange, line }) => (
//   <div className="mt-4">
//     <h3 className="text-xl font-semibold">{title}</h3>
//     <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
//       {fields.map(({ key, label, unit, readOnly }) => (
//         <InputField
//           key={`${line}-${key}`}
//           label={`${label} (${unit})`}
//           name={key}
//           value={formData[line]?.[section]?.[key] || ''}
//           onChange={handleChange}
//           type="number"
//           section={section}
//           field={key}
//           readOnly={readOnly || false} // Pass readOnly prop
//         />
//       ))}
//     </div>
//   </div>
// );

// const Form_9 = () => {
//   const navigate = useNavigate();

//   const initialFormData = (line) => {
//     const savedData = JSON.parse(sessionStorage.getItem('calibrationVerificationF9formData') || '{}')[line] || {};
//     const inspectionData = JSON.parse(sessionStorage.getItem('inspectionData') || '{}')?.calibrationVerificationOfSecondaryModule?.[line] || {};
//     const metadata = JSON.parse(sessionStorage.getItem('metadata') || '{}');
//     const calibrationData = metadata?.calibrationDataVerificationOfSe || [];
//     const calibrationEntry = calibrationData.find((entry) => entry.line === line) || {};

//     return {
//       line: line,
//       calibrationVerified: savedData.calibrationVerified || inspectionData.calibrationVerified || '',
//       serialNumber: savedData.serialNumber || inspectionData.serialNumber || calibrationEntry.SN || '',
//       alphaValue: savedData.alphaValue || inspectionData.alphaValue || calibrationEntry.Alpha || '',
//       betaValue: savedData.betaValue || inspectionData.betaValue || calibrationEntry.Beta || '',
//       gammaValue: savedData.gammaValue || inspectionData.gammaValue || calibrationEntry.Gamma || '',
//       testTime: savedData.testTime || inspectionData.testTime || '',
//       testValue: {
//         pmax: savedData.testValue?.pmax || inspectionData.testValue?.pmax || '',
//         isc: savedData.testValue?.isc || inspectionData.testValue?.isc || '',
//         voc: savedData.testValue?.voc || inspectionData.testValue?.voc || '',
//         imp: savedData.testValue?.imp || inspectionData.testValue?.imp || '',
//         vmp: savedData.testValue?.vmp || inspectionData.testValue?.vmp || '',
//         ff: savedData.testValue?.ff || inspectionData.testValue?.ff || '',
//       },
//       certifiedValues: {
//         pmax: savedData.certifiedValues?.pmax || inspectionData.certifiedValues?.pmax || calibrationEntry.PMAX || '',
//         isc: savedData.certifiedValues?.isc || inspectionData.certifiedValues?.isc || calibrationEntry.ISC || '',
//         voc: savedData.certifiedValues?.voc || inspectionData.certifiedValues?.voc || calibrationEntry.VOC || '',
//         imp: savedData.certifiedValues?.imp || inspectionData.certifiedValues?.imp || calibrationEntry.IMP || '',
//         vmp: savedData.certifiedValues?.vmp || inspectionData.certifiedValues?.vmp || calibrationEntry.VMP || '',
//         ff: savedData.certifiedValues?.ff || inspectionData.certifiedValues?.ff || calibrationEntry.FF || '',
//       },
//       differenceValue: {
//         pmax: savedData.differenceValue?.pmax || inspectionData.differenceValue?.pmax || '',
//       },
//       afterCalFlashes: {
//         moduleId: savedData.afterCalFlashes?.moduleId || inspectionData.afterCalFlashes?.moduleId || '',
//         firstFlash: savedData.afterCalFlashes?.firstFlash || inspectionData.afterCalFlashes?.firstFlash || '',
//         secondFlash: savedData.afterCalFlashes?.secondFlash || inspectionData.afterCalFlashes?.secondFlash || '',
//         thirdFlash: savedData.afterCalFlashes?.thirdFlash || inspectionData.afterCalFlashes?.thirdFlash || '',
//         averageFlash: savedData.afterCalFlashes?.averageFlash || inspectionData.afterCalFlashes?.averageFlash || '',
//       },
//     };
//   };

//   const [lines, setLines] = useState([]);
//   const [selectedLine, setSelectedLine] = useState('');
//   const [formData, setFormData] = useState({});
//   const [isLoading, setIsLoading] = useState(false);

//   useEffect(() => {
//     const metadata = sessionStorage.getItem('metadata');
//     if (metadata) {
//       try {
//         const parsedMetadata = JSON.parse(metadata);
//         const fetchedLines = parsedMetadata.lines.map((item) => item.Lines);
//         setLines(fetchedLines);
//         setSelectedLine(fetchedLines[0] || '');

//         const initialData = {};
//         fetchedLines.forEach((line) => {
//           initialData[line] = initialFormData(line);
//         });
//         setFormData(initialData);
//       } catch (error) {
//         console.error('Error parsing metadata:', error);
//       }
//     }
//   }, []);

//   useEffect(() => {
//     if (lines.length > 0 && formData[selectedLine]) {
//       setFormData((prev) => {
//         const newData = { ...prev };
//         lines.forEach((line) => {
//           if (!newData[line]) return;
//           const certifiedPmax = parseFloat(newData[line].certifiedValues.pmax) || 0;
//           const testPmax = parseFloat(newData[line].testValue.pmax) || 0;
//           newData[line].differenceValue.pmax = testPmax - certifiedPmax || '';
//         });
//         return newData;
//       });
//     }
//   }, [formData[selectedLine]?.testValue?.pmax, formData[selectedLine]?.certifiedValues?.pmax, lines]);

//   useEffect(() => {
//     if (Object.keys(formData).length > 0) {
//       sessionStorage.setItem('calibrationVerificationF9formData', JSON.stringify(formData));
//     }
//   }, [formData]);

//   const handleLineChange = (e) => {
//     setSelectedLine(e.target.value);
//   };

//   const handleChange = (e, section, field) => {
//     const { name, value } = e.target;
//     const currentTime = new Date().toTimeString().slice(0, 8);
//     setFormData((prev) => ({
//       ...prev,
//       [selectedLine]: {
//         ...prev[selectedLine],
//         testTime: section === 'testValue' && field === 'pmax' && value ? currentTime : prev[selectedLine].testTime,
//         [section || name]: field ? { ...prev[selectedLine][section], [field]: value } : value,
//       },
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);
//     try {
//       const payloadLines = lines.reduce((acc, line) => {
//         acc[line] = { ...formData[line], date: sessionStorage.getItem('inspectionDate') };
//         return acc;
//       }, {});

//       const payload = {
//         projectId: localStorage.getItem('selectedProject'),
//         inspectionSupplier: sessionStorage.getItem('inspectionSupplier'),
//         inspectionDate: sessionStorage.getItem('inspectionDate'),
//         inspectionShift: sessionStorage.getItem('inspectionShift'),
//         inspectorName: sessionStorage.getItem('username'),
//         status: 'completed',
//         calibrationVerificationOfSecondaryModule: payloadLines,
//       };

//       await submitFormData(payload);
//       alert('Form submitted successfully!');
//       setFormData((prev) => {
//         const newData = {};
//         lines.forEach((line) => {
//           newData[line] = initialFormData(line);
//         });
//         return newData;
//       });
//     } catch (error) {
//       console.error('Error submitting form:', error);
//       alert(`Failed to submit form: ${error.message || 'Unknown error'}`);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="bg-white p-6 rounded-lg shadow-lg space-y-4">
//       <h2 className="text-2xl font-bold text-center mb-4">Calibration data verification of secondary module</h2>
//       <div className="grid grid-cols-2 gap-4">
//         <InputField
//           label="Date"
//           name="date"
//           value={sessionStorage.getItem('inspectionDate') || ''}
//           onChange={() => {}}
//           type="date"
//           readOnly
//         />
//         <div>
//           <label className="block font-semibold mb-1">Select Line</label>
//           <select
//             value={selectedLine}
//             onChange={handleLineChange}
//             className="w-full p-2 border rounded focus:ring-2 focus:ring-gray-500"
//             disabled={lines.length === 0}
//           >
//             {lines.length === 0 ? (
//               <option value="">No lines available</option>
//             ) : (
//               lines.map((line) => (
//                 <option key={line} value={line}>{line}</option>
//               ))
//             )}
//           </select>
//         </div>
//       </div>

//       {lines.length > 0 && formData[selectedLine] && (
//         <form onSubmit={handleSubmit} className="space-y-4">
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <InputField
//               label="Calibration modules test report verified"
//               name="calibrationVerified"
//               value={formData[selectedLine].calibrationVerified}
//               onChange={handleChange}
//             />
//             <InputField
//               label="SN."
//               name="serialNumber"
//               value={formData[selectedLine].serialNumber}
//               readOnly
//               onChange={handleChange}
//               placeholder="Serial Number"
//             />
//             <div className="grid grid-cols-3 gap-4">
//               <InputField
//                 label="α (Alpha Value)"
//                 name="alphaValue"
//                 readOnly
//                 value={formData[selectedLine].alphaValue}
//                 onChange={handleChange}
//                 type="number"
//                 placeholder="Alpha Value"
//               />
//               <InputField
//                 label="β (Beta Value)"
//                 name="betaValue"
//                 readOnly
//                 value={formData[selectedLine].betaValue}
//                 onChange={handleChange}
//                 type="number"
//                 placeholder="Beta Value"
//               />
//               <InputField
//                 label="γ (Gamma Value)"
//                 name="gammaValue"
//                 readOnly
//                 value={formData[selectedLine].gammaValue}
//                 onChange={handleChange}
//                 type="number"
//                 placeholder="Gamma Value"
//               />
//             </div>
//             <InputField
//               label="Test Time"
//               name="testTime"
//               value={formData[selectedLine].testTime}
//               onChange={handleChange}
//               type="time"
//               step="1"
//             />
//           </div>

//           <FieldGroup
//             title="Test Value"
//             section="testValue"
//             fields={[
//               { key: 'pmax', label: 'Pmax', unit: 'W' },
//               { key: 'isc', label: 'Isc', unit: 'A' },
//               { key: 'voc', label: 'Voc', unit: 'V' },
//               { key: 'imp', label: 'Imp', unit: 'A' },
//               { key: 'vmp', label: 'Vmp', unit: 'V' },
//               { key: 'ff', label: 'FF', unit: '%' },
//             ]}
//             formData={formData}
//             handleChange={handleChange}
//             line={selectedLine}
//           />
//           <FieldGroup
//             title="Secondary module certified values"
//             section="certifiedValues"
//             fields={[
//               { key: 'pmax', label: 'Pmax', unit: 'W', readOnly: true },
//               { key: 'isc', label: 'Isc', unit: 'A', readOnly: true },
//               { key: 'voc', label: 'Voc', unit: 'V', readOnly: true },
//               { key: 'imp', label: 'Imp', unit: 'A' },
//               { key: 'vmp', label: 'Vmp', unit: 'V' },
//               { key: 'ff', label: 'FF', unit: '%' },
//             ]}
//             formData={formData}
//             handleChange={handleChange}
//             line={selectedLine}
//           />

//           <div className="mt-4">
//             <h3 className="text-xl font-semibold">Difference Value</h3>
//             <InputField
//               label="Pmax (W)"
//               name="pmax"
//               value={formData[selectedLine].differenceValue.pmax}
//               onChange={() => {}}
//               type="number"
//               section="differenceValue"
//               field="pmax"
//               placeholder="Pmax (W)"
//               readOnly
//             />
//           </div>

//           <FieldGroup
//             title="After CAL three flashes on secondary module"
//             section="afterCalFlashes"
//             fields={[
//               { key: 'moduleId', label: 'Module Id', unit: '' },
//               { key: 'firstFlash', label: 'First Flash', unit: '' },
//               { key: 'secondFlash', label: 'Second Flash', unit: '' },
//               { key: 'thirdFlash', label: 'Third Flash', unit: '' },
//               { key: 'averageFlash', label: 'Average Flash', unit: '' },
//             ]}
//             formData={formData}
//             handleChange={handleChange}
//             line={selectedLine}
//           />

//           <div className="flex justify-between mt-6">
//             <button
//               type="button"
//               onClick={() => navigate('/inspections/section2/form8')}
//               className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
//             >
//               Previous
//             </button>
//             <button
//               type="submit"
//               disabled={isLoading}
//               className={`px-4 py-2 bg-[#424752] text-white rounded hover:bg-gray-500 disabled:bg-gray-400`}
//             >
//               {isLoading ? 'Submitting...' : 'Submit'}
//             </button>
//             <button
//               type="button"
//               onClick={() => navigate('/inspections/section2/form10')}
//               className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
//             >
//               Next
//             </button>
//           </div>
//         </form>
//       )}
//     </div>
//   );
// };

// export default Form_9;

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { submitFormData } from '../../../pages/api';

// InputField component with readOnly support
const InputField = ({ label, name, value, onChange, type = 'text', section, field, readOnly = false, ...props }) => (
  <div>
    <label className="block font-semibold mb-1">{label}</label>
    <input
      type={type}
      name={name}
      value={value || ''}
      onChange={(e) => !readOnly && onChange(e, section, field)} // Prevent changes if readOnly
      readOnly={readOnly}
      className={`w-full p-2 border rounded focus:ring-2 focus:ring-gray-500 ${
        readOnly ? 'bg-gray-100 text-gray-600 cursor-not-allowed' : 'border-gray-300'
      }`}
      {...props}
    />
  </div>
);

// FieldGroup component passing readOnly to InputField
const FieldGroup = ({ title, section, fields, formData, handleChange, line }) => (
  <div className="mt-4">
    <h3 className="text-xl font-semibold">{title}</h3>
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
      {fields.map(({ key, label, unit, readOnly, type }) => (
        <InputField
          key={`${line}-${key}`}
          label={`${label} (${unit})`}
          name={key}
          value={formData[line]?.[section]?.[key] || ''}
          onChange={handleChange}
          type={type}
          section={section}
          field={key}
          readOnly={readOnly || false} // Pass readOnly prop
        />
      ))}
    </div>
  </div>
);

const Form_9 = () => {
  const navigate = useNavigate();

  const initialFormData = (line) => {
    const savedData = JSON.parse(sessionStorage.getItem('calibrationVerificationF9formData') || '{}')[line] || {};
    const inspectionData = JSON.parse(sessionStorage.getItem('inspectionData') || '{}')?.calibrationVerificationOfSecondaryModule?.[line] || {};
    const metadata = JSON.parse(sessionStorage.getItem('metadata') || '{}');
    const calibrationData = metadata?.calibrationDataVerificationOfSe || [];
    const calibrationEntry = calibrationData.find((entry) => entry.line === line) || {};

    return {
      line: line,
      calibrationVerified: savedData.calibrationVerified || inspectionData.calibrationVerified || '',
      serialNumber: savedData.serialNumber || inspectionData.serialNumber || calibrationEntry.SN || '',
      alphaValue: savedData.alphaValue || inspectionData.alphaValue || calibrationEntry.Alpha || '',
      betaValue: savedData.betaValue || inspectionData.betaValue || calibrationEntry.Beta || '',
      gammaValue: savedData.gammaValue || inspectionData.gammaValue || calibrationEntry.Gamma || '',
      testTime: savedData.testTime || inspectionData.testTime || '',
      testValue: {
        pmax: savedData.testValue?.pmax || inspectionData.testValue?.pmax || '',
        isc: savedData.testValue?.isc || inspectionData.testValue?.isc || '',
        voc: savedData.testValue?.voc || inspectionData.testValue?.voc || '',
        imp: savedData.testValue?.imp || inspectionData.testValue?.imp || '',
        vmp: savedData.testValue?.vmp || inspectionData.testValue?.vmp || '',
        ff: savedData.testValue?.ff || inspectionData.testValue?.ff || '',
      },
      certifiedValues: {
        pmax: savedData.certifiedValues?.pmax || inspectionData.certifiedValues?.pmax || calibrationEntry.PMAX || '',
        isc: savedData.certifiedValues?.isc || inspectionData.certifiedValues?.isc || calibrationEntry.ISC || '',
        voc: savedData.certifiedValues?.voc || inspectionData.certifiedValues?.voc || calibrationEntry.VOC || '',
        imp: savedData.certifiedValues?.imp || inspectionData.certifiedValues?.imp || calibrationEntry.IMP || '',
        vmp: savedData.certifiedValues?.vmp || inspectionData.certifiedValues?.vmp || calibrationEntry.VMP || '',
        ff: savedData.certifiedValues?.ff || inspectionData.certifiedValues?.ff || calibrationEntry.FF || '',
      },
      differenceValue: {
        pmax: savedData.differenceValue?.pmax || inspectionData.differenceValue?.pmax || '',
      },
      afterCalFlashes: {
        moduleId: savedData.afterCalFlashes?.moduleId || inspectionData.afterCalFlashes?.moduleId || '',
        firstFlash: savedData.afterCalFlashes?.firstFlash || inspectionData.afterCalFlashes?.firstFlash || '',
        secondFlash: savedData.afterCalFlashes?.secondFlash || inspectionData.afterCalFlashes?.secondFlash || '',
        thirdFlash: savedData.afterCalFlashes?.thirdFlash || inspectionData.afterCalFlashes?.thirdFlash || '',
        averageFlash: savedData.afterCalFlashes?.averageFlash || inspectionData.afterCalFlashes?.averageFlash || '',
      },
    };
  };

  const [lines, setLines] = useState([]);
  const [selectedLine, setSelectedLine] = useState('');
  const [formData, setFormData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const metadata = sessionStorage.getItem('metadata');
    if (metadata) {
      try {
        const parsedMetadata = JSON.parse(metadata);
        const fetchedLines = parsedMetadata.lines.map((item) => item.Lines);
        setLines(fetchedLines);
        setSelectedLine(fetchedLines[0] || '');

        const initialData = {};
        fetchedLines.forEach((line) => {
          initialData[line] = initialFormData(line);
        });
        setFormData(initialData);
      } catch (error) {
        console.error('Error parsing metadata:', error);
      }
    }
  }, []);

  // Calculate differenceValue.pmax
  useEffect(() => {
    if (lines.length > 0 && formData[selectedLine]) {
      setFormData((prev) => {
        const newData = { ...prev };
        lines.forEach((line) => {
          if (!newData[line]) return;
          const certifiedPmax = parseFloat(newData[line].certifiedValues.pmax) || 0;
          const testPmax = parseFloat(newData[line].testValue.pmax) || 0;
          newData[line].differenceValue.pmax = testPmax - certifiedPmax || '';
        });
        return newData;
      });
    }
  }, [formData[selectedLine]?.testValue?.pmax, formData[selectedLine]?.certifiedValues?.pmax, lines]);

  // Calculate averageFlash
  useEffect(() => {
    if (lines.length > 0 && formData[selectedLine]) {
      setFormData((prev) => {
        const newData = { ...prev };
        lines.forEach((line) => {
          if (!newData[line]) return;
          const { firstFlash, secondFlash, thirdFlash } = newData[line].afterCalFlashes;
          const values = [
            parseFloat(firstFlash),
            parseFloat(secondFlash),
            parseFloat(thirdFlash),
          ].filter((val) => !isNaN(val) && val !== '');
          const average =
            values.length > 0 ? (values.reduce((sum, val) => sum + val, 0) / values.length).toFixed(2) : '';
          newData[line].afterCalFlashes.averageFlash = average;
        });
        return newData;
      });
    }
  }, [
    formData[selectedLine]?.afterCalFlashes?.firstFlash,
    formData[selectedLine]?.afterCalFlashes?.secondFlash,
    formData[selectedLine]?.afterCalFlashes?.thirdFlash,
    lines,
  ]);

  useEffect(() => {
    if (Object.keys(formData).length > 0) {
      sessionStorage.setItem('calibrationVerificationF9formData', JSON.stringify(formData));
    }
  }, [formData]);

  const handleLineChange = (e) => {
    setSelectedLine(e.target.value);
  };

  const handleChange = (e, section, field) => {
    const { name, value } = e.target;
    const currentTime = new Date().toTimeString().slice(0, 8);
    setFormData((prev) => ({
      ...prev,
      [selectedLine]: {
        ...prev[selectedLine],
        testTime: section === 'testValue' && field === 'pmax' && value ? currentTime : prev[selectedLine].testTime,
        [section || name]: field ? { ...prev[selectedLine][section], [field]: value } : value,
      },
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const payloadLines = lines.reduce((acc, line) => {
        acc[line] = { ...formData[line], date: sessionStorage.getItem('inspectionDate') };
        return acc;
      }, {});

      const payload = {
        projectId: localStorage.getItem('selectedProject'),
        inspectionSupplier: sessionStorage.getItem('inspectionSupplier'),
        inspectionDate: sessionStorage.getItem('inspectionDate'),
        inspectionShift: sessionStorage.getItem('inspectionShift'),
        inspectorName: sessionStorage.getItem('username'),
        status: 'completed',
        calibrationVerificationOfSecondaryModule: payloadLines,
      };

      await submitFormData(payload);
      alert('Form submitted successfully!');
      setFormData((prev) => {
        const newData = {};
        lines.forEach((line) => {
          newData[line] = initialFormData(line);
        });
        return newData;
      });
    } catch (error) {
      console.error('Error submitting form:', error);
      alert(`Failed to submit form: ${error.message || 'Unknown error'}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg space-y-4">
      <h2 className="text-2xl font-bold text-center mb-4">Calibration data verification of secondary module</h2>
      <div className="grid grid-cols-2 gap-4">
        <InputField
          label="Date"
          name="date"
          value={sessionStorage.getItem('inspectionDate') || ''}
          onChange={() => {}}
          type="date"
          readOnly
        />
        <div>
          <label className="block font-semibold mb-1">Select Line</label>
          <select
            value={selectedLine}
            onChange={handleLineChange}
            className="w-full p-2 border rounded focus:ring-2 focus:ring-gray-500"
            disabled={lines.length === 0}
          >
            {lines.length === 0 ? (
              <option value="">No lines available</option>
            ) : (
              lines.map((line) => (
                <option key={line} value={line}>{line}</option>
              ))
            )}
          </select>
        </div>
      </div>

      {lines.length > 0 && formData[selectedLine] && (
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InputField
              label="Calibration modules test report verified"
              name="calibrationVerified"
              value={formData[selectedLine].calibrationVerified}
              onChange={handleChange}
            />
            <InputField
              label="SN."
              name="serialNumber"
              value={formData[selectedLine].serialNumber}
              readOnly
              onChange={handleChange}
              placeholder="Serial Number"
            />
            <div className="grid grid-cols-3 gap-1">
              <InputField
                label="α (Alpha value)"
                name="alphaValue"
                readOnly
                value={formData[selectedLine].alphaValue}
                onChange={handleChange}
                type="number"
                placeholder="Alpha Value"
              />
              <InputField
                label="β (Beta value)"
                name="betaValue"
                readOnly
                value={formData[selectedLine].betaValue}
                onChange={handleChange}
                type="number"
                placeholder="Beta Value"
              />
              <InputField
                label="γ (Gamma value)"
                name="gammaValue"
                readOnly
                value={formData[selectedLine].gammaValue}
                onChange={handleChange}
                type="number"
                placeholder="Gamma Value"
              />
            </div>
            <InputField
              label="Test Time"
              name="testTime"
              value={formData[selectedLine].testTime}
              onChange={handleChange}
              type="time"
              step="1"
            />
          </div>

          <FieldGroup
            title="Test Value"
            section="testValue"
            fields={[
              { key: 'pmax', label: 'Pmax', unit: 'W', type: 'number' },
              { key: 'isc', label: 'Isc', unit: 'A', type: 'number' },
              { key: 'voc', label:'Voc' , unit:'V', type: 'number' },
              { key: 'imp', label: 'Imp', unit: 'A', type: 'number' },
              { key: 'vmp', label: 'Vmp', unit: 'V', type: 'number' },
              { key: 'ff', label: 'FF', unit: '%', type: 'number' },
            ]}
            formData={formData}
            handleChange={handleChange}
            line={selectedLine}
          />
          <FieldGroup
            title="Secondary module certified values"
            section="certifiedValues"
            fields={[
              { key: 'pmax', label: 'Pmax', unit: 'W', readOnly: true },
              { key: 'isc', label: 'Isc', unit: 'A', readOnly: true },
              { key: 'voc', label: 'Voc', unit: 'V', readOnly: true },
              { key: 'imp', label: 'Imp', unit: 'A' },
              { key: 'vmp', label: 'Vmp', unit: 'V' },
              { key: 'ff', label: 'FF', unit: '%' },
            ]}
            formData={formData}
            handleChange={handleChange}
            line={selectedLine}
          />

          <div className="mt-4">
            <h3 className="text-xl font-semibold">Difference Value</h3>
            <InputField
              label="Pmax (W)"
              name="pmax"
              value={formData[selectedLine].differenceValue.pmax || ''}
              onChange={() => {}}
              type="number"
              section="differenceValue"
              field="pmax"
              placeholder="Pmax (W)"
              readOnly
            />
          </div>

          <FieldGroup
            title="After CAL three flashes on secondary module"
            section="afterCalFlashes"
            fields={[
              { key: 'moduleId', label: 'Module Id', unit: '', type: 'text' },
              { key: 'firstFlash', label: 'First Flash', unit: '', type: 'number' },
              { key: 'secondFlash', label: 'Second Flash', unit: '', type: 'number' },
              { key: 'thirdFlash', label: 'Third Flash', unit: '', type: 'number' },
              { key: 'averageFlash', label: 'Average Flash', unit: '', readOnly: true, type: 'number' }, // Set readOnly
            ]}
            formData={formData}
            handleChange={handleChange}
            line={selectedLine}
          />

          <div className="flex justify-between mt-6">
            <button
              type="button"
              onClick={() => navigate('/inspections/section2/form8')}
              className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            >
              Previous
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className={`px-4 py-2 bg-[#424752] text-white rounded hover:bg-gray-500 disabled:bg-gray-400`}
            >
              {isLoading ? 'Submitting...' : 'Submit'}
            </button>
            <button
              type="button"
              onClick={() => navigate('/inspections/section2/form10')}
              className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            >
              Next
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default Form_9;